import {map} from 'lodash';
import {
	changeStateOfGame,
	fetchContests,
	fetchContestsFailed,
	fetchContestsSuccess,
	globalError,
	subscribeToLiveScores,
	voidEvent
} from 'modules/actions';
import {ITriviaContest, ITriviaContests, ITriviaRound} from 'modules/reducers/contests_trivia';
import {getTriviaContestByID, getTriviaContests} from 'modules/selectors/contests_trivia';
import {ISagaAction} from 'modules/types';

import {Api, EnumTriviaStatesOfGame, EnumTriviaStatusType, UpShow,} from 'modules/utils';
import * as ENUMS from 'modules/utils/enums';
import {call, delay, put, select, take} from 'typed-redux-saga';
import contests_dummy_data from './dummy_data';


const IS_LOCAL_CONTESTS = process.env.REACT_APP_IS_LOCAL_DEBUG === 'true';


export const waitForContests = function* () {
	const contests = yield* select(getTriviaContests);

	if (!contests.length) {
		yield take(fetchContestsSuccess);
	}
};

export const fetchAndWaitForContests = function* () {
	yield put(fetchContests());
	yield take(fetchContestsSuccess);
};

export const fetchContestsSaga = function* () {
	try {
		if (IS_LOCAL_CONTESTS) {
			yield put(fetchContestsSuccess(contests_dummy_data as any));
		} else {
			const contests = yield* call(Api.JSON.contests);
			yield put(fetchContestsSuccess(contests || []));
		}
	} catch (e: any) {
		const error = e as Error;
		yield put(globalError(error))
		yield put(fetchContestsFailed());
	}
};


export const setRoundStatusAction = function* (action: ISagaAction<any>) {
	yield call(setRoundStatus, action.payload.round, action.payload.status)
}

export const setRoundStatus = function* (action_round: ITriviaRound, status: ENUMS.EnumTriviaStatusType) {
	try {
		const contests = yield* select(getTriviaContests);

		const new_contests: ITriviaContests = map(contests, (contest) => {
			return {
				...contest,
				rounds: map(contest.rounds, (round) => {
					if (action_round.id === round.id) {
						return {
							...round,
							status
						}
					}
					return round
				})
			}
		});

		yield put(fetchContestsSuccess(new_contests));

	} catch (e: any) {
		const error = e as Error;
		yield put(globalError(error))
		yield put(fetchContestsFailed());
	}
};

interface IParamsStatuses {
	actioned_contest: Pick<ITriviaContest, 'id' | 'status'>
	actioned_round: Pick<ITriviaRound, 'id' | 'status'>
}

export const setStatusesContestRound = function* ({actioned_contest, actioned_round}: IParamsStatuses) {
	try {
		const contests = yield* select(getTriviaContests);
		const new_contests: ITriviaContests = map(contests, (contest) => {
			return {
				...contest,
				status: actioned_contest.id === contest.id ? actioned_contest.status : contest.status,
				rounds: map(contest.rounds, (round) => {
					return {
						...round,
						status: actioned_round.id === round.id ? actioned_round.status : round.status
					}
				})
			}
		});

		yield put(fetchContestsSuccess(new_contests));

	} catch (e: any) {
		const error = e as Error;
		yield put(globalError(error))
		yield put(fetchContestsFailed());
	}
};

export const clearLiveQuestionsSaga = function* () {
	const contests = yield* select(getTriviaContests);
	const new_contests: ITriviaContests = map(contests, (contest) => {

		return {
			...contest,
			rounds: map(contest.rounds, (round) => {
				return {
					...round,
					questions: round.questions.filter((question) => {
						return question.status !== EnumTriviaStatusType.live
					})
				}
			})
		}
	});

	yield put(fetchContestsSuccess(new_contests));
}

export const setContestStatus = function* (action_contest: ITriviaContest, status: ENUMS.EnumTriviaContestStatus) {
	try {
		const contests = yield* select(getTriviaContests);

		const new_contests: ITriviaContests = map(contests, (contest) => {
			if (contest.id === action_contest.id) {
				return {
					...contest,
					status
				}
			}
			return contest
		});

		yield put(fetchContestsSuccess(new_contests));

	} catch (e: any) {
		const error = e as Error;
		yield put(globalError(error))
		yield put(fetchContestsFailed());
	}
};

export const extendContest = function* (action_contest: ITriviaContest, extends_fields: Partial<ITriviaContest>) {
	try {
		const contests = yield* select(getTriviaContests);
		const new_contests: ITriviaContests = map(contests, (contest) => {
			if (contest.id === action_contest.id) {
				return {
					...contest,
					...extends_fields
				};
			}
			return contest;
		});

		yield put(fetchContestsSuccess(new_contests));

	} catch (e: any) {
		const error = e as Error;
		yield put(globalError(error))
		yield put(fetchContestsFailed());
	}
};

export const voidContest = function* (id: number, voided_at: string) {
	try {
		yield put(voidEvent());
		const contestSelector = yield* select(getTriviaContestByID);
		const contest = contestSelector(id);

		if (contest) {
			yield call(extendContest, contest, {
				status: ENUMS.EnumTriviaContestStatus.voided,
				voided_at
			});
		}

		yield put(changeStateOfGame(EnumTriviaStatesOfGame.loading));
		yield put(subscribeToLiveScores({section: 'trivia'}));

		yield delay(60 * 1000);
		UpShow.KILL()
		yield delay(2 * 1000);
		UpShow.DONE();
	} catch (e: any) {
		console.log(e);
	}
};
